module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#crime",
      toString: function () {
        return this.url;
      }
    }